import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { useState } from 'react';
import { Queries } from '@shared/api/queries';
import { API } from '@shared/types/api';

export function useGetCardName(cardId?: string): string {
  const [cardName, setCardName] = useState('');
  useQuery<API.GetCardsQuery, API.GetCardsQueryVariables>(Queries.card.getCards, {
    variables: {
      input: {
        ids: [cardId ?? ''],
      },
    },
    skip: isNil(cardId),
    onCompleted: data => {
      data.getCards?.forEach(card => {
        setCardName(card.name);
      });
    },
  });

  return cardName;
}
